import { render, staticRenderFns } from "./Image2Image.vue?vue&type=template&id=4b96ea12&scoped=true"
import script from "./Image2Image.vue?vue&type=script&lang=js"
export * from "./Image2Image.vue?vue&type=script&lang=js"
import style0 from "./Image2Image.vue?vue&type=style&index=0&id=4b96ea12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96ea12",
  null
  
)

export default component.exports